/**
 * Paginación en memoria para endpoints que aún devuelven colección completa (detalle de actas).
 */
export function pageInMemoryList(items, query = {}) {
  const { page = 1, pageSize = 10, search } = query;
  let list = Array.isArray(items) ? items : [];
  if (search) {
    const term = String(search).toLowerCase();
    list = list.filter((row) =>
      Object.values(row).some((value) => String(value ?? '').toLowerCase().includes(term))
    );
  }
  const totalCount = list.length;
  const start = (page - 1) * pageSize;
  return {
    items: list.slice(start, start + pageSize),
    totalCount,
    page,
    pageSize
  };
}
